define('fukit/view/block/searchable.pageable.table.view',['require','exports','module','underscore','uikit/uikit','../../helpers/extend.util','./pageable.table.view','../../behavior/visual.search.behavior'],function(require, exports, module) {
  //prettier-ignore
  var _                    = require('underscore'),
      UIKit                = require('uikit/uikit'),
      ExtendUtil           = require('../../helpers/extend.util'),
      PageableTableView    = require('./pageable.table.view'),
      VisualSearchBehavior = require('../../behavior/visual.search.behavior');

  var SearchablePageableTableView = PageableTableView.extend({
    template: function() {
      return (
        '<div class="ui top attached tertiary segment"><ui name="visualSearchView" /></div>' +
        '<ui name="tableView" /><ui name="paginationView" />'
      );
    },

    options: _.extend({}, PageableTableView.prototype.options, {
      attached: 'bottom',
    }),

    internalViewOptions: PageableTableView.extendInternalViewOptions({
      visualSearchView: ExtendUtil.extendOptionValueWithDefaults('visualSearch', function() {
        return {
          type: UIKit.TokenInput,
          singleValue: false,
          freeText: false,
          validateToken: function(token) {
            return token.get('value') ? true : '';
          },
          icon: 'search',
          placeholder: 'Click to search...',
          behaviors: {
            VisualSearchBehavior: {
              behaviorClass: VisualSearchBehavior,
              availableFields: this.getOption('searchFields'),
              searchResultCollection: this.collection,
              escapeSpecialChars: this.getOption('escapeSpecialChars'),
              specialCharRegEx: this.getOption('specialCharRegEx'),
            },
          },
        };
      }),
    }),
  });
  module.exports = SearchablePageableTableView;
});

